import notesScreen from '../assets/notes-screen.svg';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero__notebook-bg">
        <div className="hero__notebook-lines">
          {Array.from({ length: 18 }).map((_, i) => (
            <div key={i} className="hero__line" />
          ))}
        </div>
        <div className="hero__notebook-margin" />
      </div>

      <div className="hero__holes">
        <div className="hero__hole" />
        <div className="hero__hole" />
        <div className="hero__hole" />
      </div>

      <div className="hero__container container">
        <div className="hero__content">
          <h1 className="hero__title">
            Not paylaş.<br />
            <span className="hero__title-accent">Daha iyi</span><br />
            materyaller keşfet.
          </h1>

          <p className="hero__subtitle">
            NoteSwapp, öğrencilerin ders notlarını bölüm, dönem ve ders bilgilerine göre düzenli şekilde paylaşmasını ve adil değiş tokuş sistemiyle yeni notlara ulaşmasını sağlar.
          </p>

          <div className="hero__actions">
            <a href="#features" className="btn-primary">
              NoteSwapp'ı Keşfet
            </a>
            <a href="#feedback" className="btn-secondary">
              Geri Bildirim Ver
            </a>
          </div>

          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-num">Ders Bazlı</span>
              <span className="hero__stat-label">Not Arama</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-num">Adil</span>
              <span className="hero__stat-label">Not Değişimi</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-num">AI Destekli</span>
              <span className="hero__stat-label">Ön Kontrol</span>
            </div>
          </div>
        </div>

        <div className="hero__visual">
          <div className="hero__phone-wrap">
            <div className="hero__phone-frame">
              <div className="hero__phone-notch" />
              <div className="hero__phone-screen">
                <img
                  src={notesScreen}
                  alt="NoteSwapp uygulama ekranı"
                  className="hero__screen-img"
                />
              </div>
            </div>
            <div className="hero__phone-shadow" />
          </div>

        </div>
      </div>

      <div className="hero__wave">
        <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path d="M0 40 C360 80 1080 0 1440 40 L1440 80 L0 80 Z" fill="#ffffff"/>
        </svg>
      </div>
    </section>
  );
}
